var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-628 371.3 23 23",
    style: {
      enableBackground: "new -628 371.3 23 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#505759;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-616.5,371.3c6.4,0,11.5,5.1,11.5,11.5s-5.1,11.5-11.5,11.5s-11.5-5.1-11.5-11.5S-622.9,371.3-616.5,371.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-615.5,382.8l2.7-2.7c0.1-0.1,0.1-0.2,0-0.3l-0.7-0.7c0,0-0.1-0.1-0.2-0.1c-0.1,0-0.1,0-0.2,0.1l-2.7,2.7 l-2.6-2.8c-0.1-0.1-0.2-0.1-0.3,0l-0.8,0.7c0,0-0.1,0.1-0.1,0.2s0,0.1,0.1,0.2l2.7,2.7l-2.7,2.7c-0.1,0.1-0.1,0.2,0,0.3l0.7,0.7 c0,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2-0.1l2.7-2.7l2.7,2.7c0.1,0.1,0.2,0.1,0.3,0l0.7-0.7c0,0,0.1-0.1,0.1-0.2c0-0.1,0-0.1-0.1-0.2 L-615.5,382.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d3aa1eb49da277522eb87a627ff44ddc.svg";
export { ForwardRef as ReactComponent };